import {getInstance as tooltip} from '../SimpleSingletonTooltip'

export default function ErrorTooltipsForSectionsController() {}

ErrorTooltipsForSectionsController.prototype.init = function( tooltipId, errorsToSectionElsMap, getErrorMessageFunction )
{
    this.errorsToSectionElsMap = errorsToSectionElsMap
    this.unsubscribeErrorTootipMouseHandlers = {}
    this.getErrorMessageFunction = getErrorMessageFunction

    return this
}

ErrorTooltipsForSectionsController.prototype.updateTooltips = function( errors )
{
    for ( let possibleError in this.errorsToSectionElsMap )
    {
        if ( this.errorsToSectionElsMap.hasOwnProperty( possibleError ) )
        {
            let error = errors.includes(possibleError) ? possibleError : null
            this.updateTooltipHandlersForSection(possibleError, error )
        }
    }
}

ErrorTooltipsForSectionsController.prototype.updateTooltipHandlersForSection = function(possibleError, error)
{
    let sectionEl = this.errorsToSectionElsMap[possibleError]
    let unsubscribeErrorTooltipHandler = this.unsubscribeErrorTootipMouseHandlers[possibleError]

    if (!sectionEl) {
        return
    }

    if (error && !unsubscribeErrorTooltipHandler) {
        this.unsubscribeErrorTootipMouseHandlers[error] = tooltip().subscribeToMouseEvents(sectionEl, () => {
            tooltip().setState({
                html: this.getErrorMessageFunction(error),
                extraClass: 'reportEditConfigErrorTooltip ' + error + 'Cls'
            })
            sectionEl.click(() => tooltip().hide())
        })
    } else if (unsubscribeErrorTooltipHandler && !error) {
        tooltip().hide()
        sectionEl.off('click')
        unsubscribeErrorTooltipHandler()
        delete this.unsubscribeErrorTootipMouseHandlers[possibleError]
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/ErrorTooltipsForSectionsController.js